import React, { useState, useEffect } from "react";
import {
  Box,
  makeStyles,
  Tab,
  Tabs,
  Typography,
} from "@material-ui/core";
import { useForm } from "react-hook-form";
import apiHelper from "../../../../util/ApiHelper";
import { toast } from "react-toastify";
import { useLoading } from "../../../../util/LoadingProvider";
import EmailTemplateSubmissionForm from "./EmailTemplateSubmissionForm";

const defaultFormValues = {
  localizations: {

  }
};

const useStyles = makeStyles((theme) => ({
  textInput: {
    backgroundColor: "white",
    width: "100%",
    marginBottom: "12px",

    "& input": {
      fontSize: "14px",
    },
  },
  content: {
    "& .ck-editor__editable_inline": {
      minHeight: "362px",
    },
  },
  buttonGroup: {
    marginTop: "20px",
    textAlign: "right",
    "& button": {
      color: "#306F9D",
      fontSize: "13px",
      textTransform: "inherit",
    },
  },
  box: {
    padding: "20px 30px 10px",
    background: "#ffffff",
    minHeight: "800px",
  },
}));

function TabPanel(props) {
  const classes = useStyles();
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`nav-tabpanel-${index}`}
      aria-labelledby={`nav-tab-${index}`}
      {...other}
    >
      <Box p={3} className={classes.box}>
        {children}
      </Box>
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `nav-tab-${index}`,
    "aria-controls": `nav-tabpanel-${index}`,
  };
}

export default function EmailContentSettingPage({ disabled, ...props }) {
  const [defaultValues, setDefaultValues] = useState(defaultFormValues);
  const [initialValues, setInitialValues] = useState(null);
  const [activeTab, setActiveTab] = useState(0);
  const [orderStatusId, setOrderStatusId] = React.useState({});
  const [tabStatusId, setTabStatusId] = React.useState(null);
  const { setLoading } = useLoading();

  const classes = useStyles();

  const {
    control,
    handleSubmit,
    setValue,
  } = useForm({
    defaultValues: React.useMemo(() => defaultValues, [defaultValues]),
  });

  const onSubmit = (value) => {
    updateTransactionEmailById(value);
  };

  const getOrderStatus = async () => {
    try {
      const result = await apiHelper.hkiff.getTransactionOrderStatus();
      var orderStatus = {};
      result.data.map(function(x){
        orderStatus[x.id] = x.title;
      })
      setOrderStatusId(orderStatus);
    } catch (err) {
      console.log(err);
    }
  };

  const getTransactionEmail = async () => {
    setLoading(true);
    try {
      const result = await apiHelper.hkiff.getTransactionEmail();
      console.log(result);
      setInitialValues(result.data.content);
      setDefaultValues(result.data.content);
      var tabStatus = {};
      result.data.content.map(function (x, i) {
        tabStatus[i] = x.id;
      })
      setTabStatusId(tabStatus);
    } catch (err) {
      console.log(err);
    }
    setLoading(false);
  };

  useEffect(() => {
    getOrderStatus();
    getTransactionEmail();
  }, []);

  const updateTransactionEmailById = async (value) => {
    try {
      value.data.map(function(v,i){
        if(v.localizations.en.title == undefined){
          v.localizations.en.title = initialValues[i].localizations.en.title;
        }
        if (v.localizations.tc.title == undefined) {
          v.localizations.tc.title = initialValues[i].localizations.tc.title;
        }
      })

      const req = value.data[activeTab];
      const result = await apiHelper.hkiff.updateTransactionEmailById(tabStatusId[activeTab], req);
      console.log(result);
      if (result.status === 200) {
        await getTransactionEmail();
        toast.dark("Your changes is saved.");
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <div className={classes.content}>
      <Box width="100%">
        <Typography variant="h4" gutterBottom>
          eShop &gt; Email Content Setting
        </Typography>
      </Box>
      <Tabs
        value={activeTab}
        onChange={handleChange}
        aria-label="nav tabs example"
        TabIndicatorProps={{ style: { top: "0", background: "#306F9D" } }}
      >
        {initialValues && initialValues.map(function (p) {
          return (
            <Tab label={orderStatusId[p.id]} {...a11yProps(p.id)} />
          )
        })}
      </Tabs>
      
      {initialValues && initialValues.map(function (p,i) {
        return (
        <>
          <TabPanel value={activeTab} index={i}>
            <EmailTemplateSubmissionForm
              tabId={i}
              status={orderStatusId[p.id]}
              initialValues={initialValues}
              handleSubmit={handleSubmit}
              onSubmit={onSubmit}
              control={control}
              classes={classes}
              disabled={disabled}
            />
          </TabPanel>
        </>
        )
      })}
    </div>
  );
}
